import React from 'react'
import MaterialSymbol from '../material-symbol'

const CalendarAddOn = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="calendar_add_on" {...props} />
))

CalendarAddOn.displayName = 'CalendarAddOn'

export default CalendarAddOn
